import React, { useEffect, useRef, useState } from "react";

function TermsForMentor(props) {
  const divRef = useRef(null);

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = divRef.current;
    console.log(
      "is scrollable",
      scrollTop,
      scrollHeight,
      scrollTop + clientHeight,
      clientHeight
    );
    if (scrollTop + clientHeight + 1 >= scrollHeight) {
      props.checkBtn(false);
      console.log("is bottom");
    } 
  };
  useEffect(() => {
    const doScroll = () => {
      const element = divRef.current;
      if (element) {
        // Check if the user has scrolled to the bottom
        const isBottom =
          element.scrollHeight - element.scrollTop === element.clientHeight;
      console.log("check bottom", isBottom, element.scrollHeight, element.scrollTop, element.clientHeight);

        if (isBottom) {
          props.checkBtn(false);
        }
      }
    };

    const element = divRef.current;
    element.addEventListener("scroll", doScroll());

    return () => {
      element.removeEventListener("scroll", doScroll());
    };
  }, []);

  return (
    <div className="terms-div" onScroll={() => handleScroll()} ref={divRef}>
      {termsAndConditions.map((section, index) => (
        <div className="terms" key={index}>
          <h2>
            {index + 1}. {section.title}
          </h2>
          {section.content.map((paragraph, pIndex) => (
            <p className="subTitle" key={pIndex}>
              {paragraph.includes(
                "https://firstimpactscholarships.idfcfirstbank.com"
              ) ? (
                <>
                  By clicking the link and accessing on{" "}
                  <a
                    href="https://firstimpactscholarships.idfcfirstbank.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://firstimpactscholarships.idfcfirstbank.com
                  </a>{" "}
                  portal, the scholar shall unconditionally accept and agrees to
                  comply with and be bound by these Terms and Conditions, as in
                  force and the changes thereto from time to time as
                  communicated and / or made available on the Website
                  (www.idfcfirstbank.com) of the Bank. Without prejudice to the
                  foregoing, the use of the facility by the scholar will be
                  deemed acceptance of the Terms and Conditions. No act, delay
                  or omission by the Bank or a Mentor shall affect its rights,
                  powers and remedies under these Terms and Conditions.
                </>
              ) : paragraph.includes("Please abide by the terms") ? (
                <>
                  Please abide by the terms mentioned{" "}
                  <a
                    href="https://www.idfcfirstbank.com/cbdc-privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    here
                  </a>
                  .
                </>
              ) : (
                paragraph
              )}
            </p>
          ))}
        </div>
      ))}
      <div></div>
    </div>
  );
}

export default TermsForMentor;
const termsAndConditions = [
  {
    title: "Scope",
    content: [
      "This document lays out the Terms and Conditions which shall be applicable to the scholar of Master of Business Administration (“scholar”) applying assistance under mentorship program (“program”) of IDFC FIRST Bank Limited (“IDFC FIRST Bank/ Bank”) under its CSR Scholarship Program.",
      "The sole purpose of this program is to help students for skill development and career guideline.",
    ],
  },
  {
    title: "Acceptance",
    content: [
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      `By clicking the link and accessing on https://firstimpactscholarships.idfcfirstbank.com portal, the scholar shall unconditionally accept and agrees to comply with and be bound by these Terms and Conditions, as in force and the changes thereto from time to time as communicated and / or made available on the Website (www.idfcfirstbank.com) of the Bank. Without prejudice to the foregoing, the use of the facility by the scholar will be deemed acceptance of the Terms and Conditions. No act, delay or omission by the Bank or a Mentor shall affect its rights, powers and remedies under these Terms and Conditions.`,
    ],
  },
  {
    title: "General Conditions",
    content: [
      "3.1. Subject to the terms and condition, the scholar shall be eligible to get benefit under this scheme till completion of their MBA course.",
      "3.2. This program is only for the scholar eligible under MBA Scholarship program under CSR activities of the Bank, in case beneficiary scholar disqualify for the MBA Scholarship program subsequent stage after the appointment of Mentor, the Bank shall reserve the right to terminate mentorship assistance under this scheme.",
      "3.3. Attending this program does not give right to the student or obligatory for the Bank to offer employment to any of the student.",
      "3.4. Scholar shall not solicit with the Mentor, any other assistance apart from the subject matter.",
      "3.5. It is the sole discretion of the Bank as well as the mentor to allow and/or continue student as his/her mentee.",
      "3.6. Scholar is expected to participate actively, attend mentorship sessions regularly as scheduled and submit their assignment, project etc on time.",
      "3.7. Scholar shall follow the timelines of the schedule",
      "3.8. Scholar shall not change mentor selected by them during the program unless the mentor and/or the Bank from acting as Mentor and discontinues his/her association with the said CSR Program",
      "3.9. The Bank shall allocate new mentor on discontinuation of existing mentor his/her association with the Bank or express his/her unwillingness. Same shall be as per Bank’s absolute discretion.",
      "3.10. The Bank may, without prior intimation to the Scholar, discontinue this program at its own discretion or due to change in law or regulation.",
      "3.11. The Scholar shall be bound to keep confidentiality and the information or data gathered during the course of mentorship and shall not disclose it to third parties without prior written consent of the Bank and upon completion of the mentorship, Scholar shall return or destruction of all confidential information received by the Scholar.",
      "3.12. The Scholar Acknowledge that any advice/information provided by the mentor is based on their experience and expertise, and should not be considered professional advice unless explicitly stated otherwise.",
      "3.13. The Mentor and/or Bank shall entitle to terminate Scholar from these services if observe any activity of the Scholar which is unethical, illegal, violating any of the policy of the Bank, or may damage reputation of the Bank.",
      "3.14. Scholar is aware that the Bank may maintain and store all logs for the data, audio and video recording of the training session.",
      "3.15. The Scholar shall not upload any social media post or give reference on any social platform related to the Program without prior written permission of the Bank.",
      "3.16. Scholar shall not do any screen recording of training or interaction with the Mentor.",
      "3.17. All the advise and training given to the Scholar by the mentor is mentor’s own view and transaction between Scholar and the Mentor, Bank is nowhere assure Scholar on accuracy of the information provided by the Mentor during the session.",
      "3.18. Communication : The Bank and the Mentor may make all communication through an electronic mode and deemed to have been received by the Scholar when the mentor, Bank and or its facilitator send the electronic communication to the email address / mobile number / details provided by the Scholar.",
      "3.19. Indemnity: The Students Indemnify and keep indemnified the Bank from any claims, damages, losses, or liabilities arising from actions or decisions made by the mentee based on advice or guidance provided by the mentor.",
    ],
  },
  {
    title: "Personal Data",
    content: [
      "4.1. The Bank will collect and store all personal details like name, age, date of birth, contact details, qualification, photograph, video recording etc (“Data”) of the Student and the Students explicitly agree that the Bank shall store and process Data for the purpose of mentoring and training to the Scholar and a legal obligation.",
      "4.2. The Bank shall retain, use and share such data as an when it requires for legitimate purpose.",
      "4.3. The Scholar is aware that he/she may also have rights of access, correction, restrict, withdrawal or nomination in respect of his/her personal Data.",
      "4.4. The Scholar shall reach out to the Bank Data privacy SPOC or sent email to mbascholarship@idfcbank.com (for MBA scholars) & engineeringscholarship@idfcbank.com (for Engineering scholars) in case of any query or concern.",
    ],
  },
  {
    title: "Execution",
    content: [
      "The Scholar hereby expressly acknowledge and confirm that the Scholar has read, verified, understood, irrevocably agreed to and accepted and delivered all the terms and conditions contained herein online by ticking / clicking / checking the 'I/we Agree' or 'I/we Agree and Accept' or any similar icon/tab/option on the online system / Website / portal / platform of Bank or its service provider as well as by entering the one time password ('OTP') provided to the Scholar’s mobile number registered with the Bank.",
      "Please abide by the terms mentioned here.",
    ],
  },
];
